import {
  createStudy,
  createSubject,
  createUniversity,
  updateStudy,
} from "@API/services/EntitiesCrud";
import {
  Label,
  SettingsInput,
  SettingsSubmitButton,
} from "@components/AdminDashboard/SubPages/Settings/commonComponents/FormComponents";
import { ReactToast } from "@lib/toast";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { object, string } from "yup";
import { useTranslation } from "react-i18next";

// styled-components ----
const Container = styled.div`
  margin-top: 1.875rem;
  display: flex;
  flex-direction: column;
  padding: 1.875rem;
  padding-top: 0rem;
`;
const Form = styled.form``;
const IconLabel = styled(Label)`
  margin-top: 1.25rem;
`;
const NameInput = styled(SettingsInput)`
  margin-top: 0.625rem;
`;
const UniversitySubmitButton = styled(SettingsSubmitButton)`
  margin-top: 5rem;
`;
// ----------------------

const NAME = "study-name";

function AddStudyForm({
  universityId,
  onCreate,
  edit,
}: {
  universityId: string;
  onCreate: () => void;
  edit?: {
    studyId: string;
    studyName: string;
  };
}) {
  const formik = useFormik({
    initialValues: {
      [NAME]: "",
    },
    validationSchema: object({
      [NAME]: string().required("name field is required").min(5),
    }),
    onSubmit: async (values, actions) => {
      if (edit) {
        const res = await updateStudy(values[NAME], edit.studyId);
        if (res.success) {
          ReactToast("Study updated");
          actions.resetForm();
          onCreate();
        } else {
          ReactToast("Couldn't update study");
        }
      } else {
        const res = await createStudy(values[NAME], universityId);
        if (res.success) {
          ReactToast("Study created");
          actions.resetForm();
          onCreate();
        } else {
          ReactToast(res.error);
        }
      }

      actions.setSubmitting(false);
    },
  });
  useEffect(() => {
    if (edit) {
      formik.setFieldValue(NAME, edit.studyName);
    }
  }, []);
  const { t } = useTranslation();

  return (
    <Container>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          formik.handleSubmit();
        }}
      >
        <Label>
          {t("adminSettings.universityStudySubjectPage.studiesPage.studyName")}
        </Label>
        <NameInput
          placeholder={t(
            "adminSettings.universityStudySubjectPage.studiesPage.studyName"
          )}
          {...formik.getFieldProps(NAME)}
        />
        <UniversitySubmitButton loading={formik.isSubmitting}>
          {edit
            ? "Edit study"
            : t(
                "adminSettings.universityStudySubjectPage.studiesPage.addStudy"
              )}
        </UniversitySubmitButton>
      </Form>
    </Container>
  );
}

export default AddStudyForm;
